import { Injectable } from '@angular/core';
import{LoginService} from '../app/globalservices/login.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { SessionHelper } from './components/shared/services/localstorage';

@Injectable()
export class AuthGuard implements CanActivate {
    path: ActivatedRouteSnapshot[];
    route: ActivatedRouteSnapshot;
    constructor(private loginService:LoginService,private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (SessionHelper.isLoggedIn()) {
            this.loginService.changeStatus(true);
            return true;
        } else {
            this.router.navigate(['']);
            this.loginService.changeStatus(false);
            return false;
        }

    }
}